module.exports = __webpack_public_path__ + "static/floor-3-ee2ec7d13ab8ac13871a1c787c016822.png";